export default __webpack_public_path__ + "static/media/img-0449-luxembourg-half-face.b0e7cf2e.png";